import { snakeToText, } from "@utils/helperFunctions";

export const getSecondaryButtonByStatus = (status, fieldLabels) => {
  switch (status) {
    case "building":
      let label = fieldLabels ? fieldLabels["request_approval"] : "Request Approval";
      return { class: "btnSeawhite", text: label };
      break;
    case "approval":
      return { class: "btnRedSecondary", text: "Cancel Approval" };
      break;
    case "approvedPsa":
      return { class: "btnSeawhite", text: "Push To PSA" };
      break;
    case "wonPsa":
      return { class: "btnSeawhite", text: "Push To PSA" };
      break;
    default:
      return {
        class: "",
        text: "",
      };
      break;
  }
};

const translateStatus = (projectStatus, statusLabels) => {
  return statusLabels.find(item => item.status == projectStatus)?.label || snakeToText(projectStatus);
}

export const getHeaderStatus = (projectStatus, statusLabels) => {
  switch (projectStatus) {
    case "building":
      return {
        class: "buildingStatus",
        text: translateStatus("building", statusLabels),
      };
      break;
    case "technical_approval":
      return {
        class: "pendingStatus",
        text: "Pending Approval",
      };
      break;
    case "sales_approval":
      return {
        class: "pendingStatus",
        text: "Pending Approval",
      };
      break;
    case "business_approval":
      return {
        class: "pendingStatus",
        text: "Pending Approval",
      };
      break;
    case "approved":
      return {
        class: "approvedStatus",
        text: translateStatus("approved", statusLabels),
      };
      break;
    case "won":
      return {
        class: "wonStatus",
        text: translateStatus("won", statusLabels),
      };
      break;
    case "lost":
      return {
        class: "lostStatus",
        text: translateStatus("lost", statusLabels),
      };
      break;
    case "canceled":
      return {
        class: "canceledStatus",
        text: "Canceled",
      };
      break;

    default:
      return { class: "building", text: "Building" };
      break;
  }
};

export const STATUS_LABEL_KEYS = [
  "building",
  "technical_approval",
  "sales_approval",
  "business_approval",
  "approved",
  "lost",
  "won",
];

export type StatusLabel = { status: string; label: string };

export const statusLabelsFrom = (
  fieldLabels?: Record<string, string | undefined>
): StatusLabel[] =>
  STATUS_LABEL_KEYS.map((status) => ({
    status,
    label: fieldLabels?.[status] || snakeToText(status),
  }));

const KNOWN_PROJECT_STATUSES: string[] = [...STATUS_LABEL_KEYS, "canceled"];

export const projectStatusText = (
  status: string,
  fieldLabels?: Record<string, string | undefined>
): string =>
  // getHeaderStatus falls back to "Building" for statuses it doesn't know
  // (e.g. a change order's reference_only), so only ask it about project ones.
  KNOWN_PROJECT_STATUSES.includes(status)
    ? getHeaderStatus(status, statusLabelsFrom(fieldLabels)).text
    : snakeToText(status);

export const getProfit = (project) => {
  return (
    Number(project?.attributes?.["contract-revenue"]) -
    Number(project?.attributes?.["contract-cost"])
  ).toFixed(2);
};

export const getMargin = (project) => {
  const margin = (
    (Number(getProfit(project)) /
      Number(project?.attributes?.["contract-revenue"])) *
    100
  ).toFixed(2);
  return margin == "NaN" ? 0 : margin;
};
